export const Constants = {
    MenuItems: {
        personal: [
            { path: 'Dashboard', icon: 'dashboard', text: 'Home', role: 'all' },
            //{ path: 'MyTasks', icon: 'new_releases', text: 'My Tasks', role: 'all' },
            { path: 'Me', icon: 'info', text: 'My Info', role: 'all' },
            { path: 'ListTimeOff', icon: 'beach_access', text: 'My Time Off', role: 'all' },
            { path: 'MyBenefits', icon: 'card_membership', text: 'My Benefits', role: 'all' },
            { path: 'BenefitMarketplace', icon: 'card_giftcard', text: 'Marketplace', role: 'all' },
        ],
        company: [
            { path: 'ApproveTimeOff', icon: 'fact_check', text: 'Timeoff Requests', role: 'MgrOrHR' },
            { path: 'Employee', icon: 'list', text: 'Employees', role: 'all' },
            { path: 'ListCalendars', icon: 'calendar_today', text: 'Calendar', role: 'all' },
            { path: 'Announcement', icon: 'volume_up', text: 'Announcements', role: 'all' },
            // { path: 'Benefits', icon: 'fa fa-gift', text: 'Benefits Manager', role: 'all' }, // todo : simplify
            { path: 'Backoffice', icon: 'keyboard', text: 'Backoffice', role: 'all' },
            { path: 'Company', icon: 'business', text: 'Company Settings', role: 'HR', mt: 5 },
            //{ path: 'membership', icon: 'credit_card', text: 'Membership Plan', role: 'HR' },
            // { path: 'membership', icon: 'fa fa-chart-line', text: 'Reports', role: 'HR' }, // todo : new
            // { path: 'ListLeaveTypes', icon: 'fa fa-tasks', text: 'Timeoff Manager', role: 'HR' }, // todo : new
        ],
        // resources: [
        // { path: 'Employee', icon: 'fa fa-clone', text: 'Contracts & Templates', role: 'all' }, // todo: new
        // { path: 'Benefits', icon: 'fa fa-gavel', text: 'Legal Aid', role: 'all' }, // todo : new
        // { path: 'Company', icon: 'fa fa-life-ring', text: 'Guides', role: 'HR' }, // todo : new
        // { path: 'listAnnouncements', icon: 'fa fa-comments', text: 'FAQ', role: 'all' }, // todo : new
        // ]
    },
    HttpErrResponse: {
        FBErrEmailLinkActivation: 'There was an error sending email link. Please ask admin to resend activation link.',
        RegistrationErrorMessage: 'Your request was not registered. Please check with admin and try again.',
        GenericNetworkError: 'We are having troubles connecting to server. Please try again in a minute.',
        GenericError: 'An error occurred connecting to backend. Please try again later',
        RequestValidationErr: 'Request Validation failed',
    },
    ConfirmPassword: {
        Required: 'Please confirm your password',
        DoesNotMatch: 'Password does not match confirmed password',
    },
    Messages: {
        RegistrationOKStart: 'Your account is successfully registered with LessAdmin.',
        RegistrationOKMiddle: 'We have sent you a verification email with a link you need to click in order to activate the account. Please follow the instructions provided on email.',
        ConfirmActivationTitle: 'Your account has been successfully activated.',
        ConfirmActivationBody: 'You should secure your account immediately by changing your password. Please click on the link below, to change your password.',
    },
    Background: {
        Start: 'rgba(182,168,174,0.33)',
        End: 'rgba(27, 27, 27, 0.74)',
    },
    Events: {
        Refresh: 'refresh',
        Alert: 'handleAlert',
    },
    Login: {
        Error: {
            UserNotFound: 'Your email is not registered with us. Please register and try again',
            WrongPassword: 'Wrong password. Please reset your password and try again',
            InactiveAccount: 'Your account is inactive. Please check the instructions on your email.',
        },
    },
    Company: {
        Messages: {
            Error: {
                CompanyIDNotFound: 'Could not find company-id',
                Edit: 'Error saving company information. Please retry after sometime.',
                Get: 'Error getting company information. Please retry after sometime.',
            },
        },
        Types: [
            'Agency',
            'Banking and finance',
            'Communications',
            'Construction',
            'Consulting',
            'Engineering',
            'Hotels & restaurants',
            'Media',
            'Non-profit',
            'Other',
            'Public sector',
            'Technology & IT',
        ],
        Status: {
            Registered: 'Registered',
            Active: 'Active',
            All: ['Registered', 'Active'],
        },
    },
    Locations: {
        Messages: {
            Error: {
                Find: 'Error while searching company locations. Please retry after sometime.',
                Add: 'Error adding the company location. Please retry after sometime.',
                Edit: 'Error saving the company location. Please retry after sometime.',
                Delete: 'Error deleting the company location. Please retry after sometime.',
                Get: 'Error finding the location details. Please retry after sometime.',
            },
        },
    },
    PhoneNumber: {
        Messages: {
            Error: {
                Required: 'Phone number is required',
                InvalidFormat: 'Phone number format is invalid',
                InvalidCountryCode: 'Phone number is invalid for this country',
                SelectISD: 'Please select country code',
            },
        },
    },
    Departments: {
        Messages: {
            Error: {
                Find: 'Error while searching departments. Please retry after sometime.',
                Add: 'Error adding the department. Please retry after sometime.',
                Edit: 'Error saving the department. Please retry after sometime.',
                Delete: 'Error deleting the department. Please retry after sometime.',
                Get: 'Error finding the department details. Please retry after sometime.',
            },
        },
    },
    Workflows: {
        Messages: {
            Error: {
                Find: 'Error while searching workflows. Please retry after sometime.',
                Add: 'Error adding the workflow. Please retry after sometime.',
                Edit: 'Error saving the workflow. Please retry after sometime.',
                Delete: 'Error deleting the workflow. Please retry after sometime.',
                Get: 'Error finding the workflow details. Please retry after sometime.',
            },
        },
        TypeOnBoarding: 'OnBoarding',
        TypeOffBoarding: 'OffBoarding',
        TypeCustom: 'Custom',
        Types: ['OnBoarding', 'OffBoarding', 'Custom'],
        CompletionTypes: ['Specified', 'NotSpecified', 'StartDate'],
    },
    BackOffice: {
        Messages: {
            Error: {
                Find: 'Error while searching backoffice items. Please retry after sometime.',
                Add: 'Error adding the backoffice item. Please retry after sometime.',
                Edit: 'Error saving the backoffice item. Please retry after sometime.',
                Delete: 'Error deleting the backoffice item. Please retry after sometime.',
                Get: 'Error finding the backoffice item details. Please retry after sometime.',
            },
        },
        Types: {
            Policies: 'Policies',
            General: 'General',
            Training: 'Training',
            Handbooks: 'Handbooks',
            Templates: 'Templates',
            All: ['Policies', 'General', 'Training', 'Handbooks', 'Templates'],
            Obj: [
                { name: 'general', value: 'General' },
                { name: 'policies', value: 'Policies' },
                { name: 'training', value: 'Training' },
                { name: 'handbooks', value: 'Handbooks' },
                { name: 'templates', value: 'Templates' },
            ],
        },
    },
    LeaveTypes: {
        Messages: {
            Error: {
                Add: 'Error adding leave type. Please retry after sometime',
                Find: 'Error finding leave types. Please retry after sometime',
                Delete: 'Error deleting leave type. Please retry after sometime',
                Edit: 'Error updating leave type. Please retry after sometime',
                Get: 'Error getting leave-type details. Please retry after sometime',
                Admin: 'Error finding policies from admin namespace. Please retry after sometime',
            },
            Applied: 'Applying the selected timeOff policy.',
            Workdays: [
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
                'Sunday',
            ],
            AccrualEarnFrequency: ['Annual', 'Monthly', 'BiWeekly', 'Weekly'],
            AccrualEarnAt: [
                { text: 'Start of the period', value: 'Start' },
                { text: 'End of the period', value: 'End' },
            ],
            RestrictionPeriods: ['Year', 'Month'],
            CarryoverStartDate: [
                { name: 'Employee start date', value: 'Employee' },
                { name: 'Policy start date', value: 'Policy' },
            ],
            ApprovalType: ['Single', 'Auto'],
            SelectedWorkdays: [
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
            ],
            Policy: 'Policy',
        },
    },
    Roles: {
        HR: 'HR',
        Manager: 'Manager',
        Employee: 'Employee',
        MgrOrHR: 'MgrOrHR',
        All: ['HR', 'Manager', 'Employee'],
    },
    MarketPlace: {
        Type: { B2B: 'B2B', B2C: 'B2C' },
        Types: [
            { name: 'B2B', value: 'B2B' },
            { name: 'Consumer', value: 'B2C' },
        ],
        Status: {
            Active: 'Active',
            Inactive: 'Inactive',
            Applied: 'Applied',
            Rejected: 'Rejected',
        },
        Statuses: [
            { name: 'Active', value: 'Active' },
            { name: 'Inactive', value: 'Inactive' },
        ],
        Unit: {
            Item: 'Item',
            Person: 'Person',
            Company: 'Company',
        },
        Units: [
            { name: 'Item', value: 'Item' },
            { name: 'Person', value: 'Person' },
            { name: 'Company', value: 'Company' },
        ],
        Category: {
            Insurance: 'Insurance',
            Pension: 'Pension',
            LoansAndFinancials: 'Loans & Financials',
            Exercise: 'Exercise',
            LearningAndSelfDevelopment: 'Learning & SelfDevelopment',
            NewsAndMedia: 'News & Media',
            TravelAndLeisure: 'Travel & Leisure',
            HealthAndMedical: 'Health & Medical',
            MobileAndCommunication: 'Mobile & Communication',
            ITDesignAndDevelopment: 'IT Design & Development',
            Agency: "Agency",
            Construction: "Construction",
            Consulting: "Consulting",
            Engineering: "Engineering",
            HotelsAndRestaurant: "Hotels and restaurants",
            NonProfit: "Non-profit",
            Other: "Other",
            PublicSector: "Public sector",
            TechnologyAndIT: "Technology and IT",
        },
        Categories: [
            'Insurance',
            'Pension',
            'Loans & Financials',
            'Exercise',
            'Learning & SelfDevelopment',
            'News & Media',
            'Travel & Leisure',
            'Health & Medical',
            'Mobile & Communication',
            'IT Design & Development',
            "Agency",
            "Construction",
            "Consulting",
            "Engineering",
            "Hotels and restaurants",
            "Non-profit",
            "Other",
            "Public sector",
            "Technology and IT"
        ],
        Messages: {
            Error: {
                Find: 'Error finding the market place offers. Please retry after sometime.',
                Get: 'Error finding the market place offer detail. Please retry after sometime.',
                Edit: 'Error editing the market place offers. Please retry after sometime.',
                Delete: 'Error deleting the market place offers. Please retry after sometime.',
                Add: 'Error adding the market place offers. Please retry after sometime.',
            },
        },
    },
    Benefits: {
        Messages: {
            Error: {
                Add: 'Error adding benefit. Please retry after sometime',
                Find: 'Error finding benefits. Please retry after sometime',
                Delete: 'Error deleting benefit. Please retry after sometime',
                Edit: 'Error updating benefit. Please retry after sometime',
                Get: 'Error getting benefit details. Please retry after sometime',
                List: 'Error getting benefit list. Please retry after sometime',
                BenefitAlreadyExists: 'Benefit already exists',
            },
        },
        Category: {
            Insurance: 'Insurance',
            Custom: 'Custom',
            Pension: 'Pension',
            LoansAndFinancials: 'Loans & Financials',
            Exercise: 'Exercise',
            LearningAndSelfDevelopment: 'Learning & SelfDevelopment',
            NewsAndMedia: 'News & Media',
            TravelAndLeisure: 'Travel & Leisure',
            HealthAndMedical: 'Health & Medical',
            MobileAndCommunication: 'Mobile & Communication',
            ITDesignAndDevelopment: 'IT Design & Development',
            Agency: "Agency",
            Construction: "Construction",
            Consulting: "Consulting",
            Engineering: "Engineering",
            HotelsAndRestaurant: "Hotels and restaurants",
            NonProfit: "Non-profit",
            Other: "Other",
            PublicSector: "Public sector",
            TechnologyAndIT: "Technology and IT",
            All: [
                'Insurance',
                'Pension',
                'Loans & Financials',
                'Exercise',
                'Learning & SelfDevelopment',
                'News & Media',
                'Travel & Leisure',
                'Health & Medical',
                'Mobile & Communication',
                'IT Design & Development',
                "Agency",
                "Construction",
                "Consulting",
                "Engineering",
                "Hotels and restaurants",
                "Non-profit",
                "Other",
                "Public sector",
                "Technology and IT"
            ],
        },
        EntityAlreadyExists: 'entity already exists',
        Status: {
            Active: 'Active',
            Inactive: 'Inactive',
            All: ['Active', 'Inactive'],
            Obj: [
                { name: 'Active', value: 'Active' },
                { name: 'Inactive', value: 'Inactive' },
            ],
        },
        Type: {
            B2B: 'B2B',
            B2C: 'B2C',
            All: ['B2B', 'B2C'],
            Obj: { B2B: 'B2B', B2C: 'B2C' },
            Select: [
                { name: 'For employees', value: ['B2C'] },
                { name: 'For businesses', value: ['B2B'] },

            ],
            Select2: [
                { name: 'For employees', value: 'B2C' },
                { name: 'For businesses', value: 'B2B' },

            ],
            Filter: [
                { name: 'For employees', value: ['B2C'] },
                { name: 'For businesses', value: ['B2B'] },
            ],
        },
        Source: {
            LessAdminOffers: 'LessAdmin offers',
            CommunityOffers: 'Community offers',
            All: ['LessAdmin offers', 'Community offers'],
            Obj: { LessAdminOffers: 'LessAdmin offers', CommunityOffers: 'Community offers' },
            Select: [
                { name: 'LessAdmin offers', value: "true" },
                { name: 'Community offers', value: "false" },
            ],
        },
        Unit: {
            Item: 'Item',
            Person: 'Person',
            Company: 'Company',
            All: ['Item', 'Person', 'Company'],
            Obj: [
                { name: 'Item', value: 'Item' },
                { name: 'Person', value: 'Person' },
                { name: 'Company', value: 'Company' },
            ],
        },
        Sorting: {
            Newest: 'Newest',
            Upvoted: 'Upvoted',
            Recommended: 'Recommended',
            All: ['Newest', 'Upvoted', 'Recommended'],
        },
    },
    TimeOff: {
        Criteria: {
            Me: 'me',
        },
        Status: {
            Pending: 'Pending',
            Rejected: 'Rejected',
            Approved: 'Approved',
            All: ['Pending', 'Rejected', 'Approved'],
        },
        Messages: {
            Error: {
                Add: 'Error adding the timeOff request. Please retry after sometime',
                Edit: 'Error editing the timeOff request. Please retry after sometime',
                Delete: 'Error deleting the timeOff request. Please retry after sometime',
                Get: 'Error fetching the timeOff request details. Please retry after sometime',
                Find: 'Error finding the timeOff request. Please retry after sometime',
            },
        },
    },
    Membership: {
        Status: {
            Active: 'Active',
            Cancelled: 'Cancelled',
            Inactive: 'Inactive',
            All: ['Active', 'Cancelled', 'Inactive'],
        },
        Type: {
            Standard: 'Standard',
            Starter: 'Starter',
            Growth: 'Growth',
            Enterprise: 'Enterprise',
            All: ['Standard', 'Starter', 'Growth', 'Enterprise'],
        },
        PaymentStatus: {
            Paid: 'Paid',
        },
    },
    Employee: {
        Messages: {
            Info: {
                Personal: 'Personal information saved',
                Address: 'Address information saved',
                Emergency: 'Emergency information saved',
                Work: 'Work information saved',
                Bank: 'Banking information saved',
                StartOnBoarding: 'Employee details saved, please start on-boarding',
                DemoMode: 'You are in demo mode, please add payment detail for full version',
                Delete: 'Employee deleted',
            },
            Error: {
                Add: 'Could not add employee info, please try again later',
                Edit: 'Could not save employee details, please try again later',
                Get: 'Could not get employee, please try again later',
                Find: 'Could not get employee list, please try again later',
                Delete: 'Could not delete employee, please try again later',
                Info: 'Could not get additional info, please try again later',
                Timeline: 'Could not get employee timeline, please try again later',
            },
        },
        Type: {
            Demo: 'Demo',
            Active: 'Active',
            Registered: 'Registered',
            Inactive: 'Inactive',
            Terminate: 'Terminated',
            All: ['Demo', 'Active', 'Registered', 'Inactive', 'Terminated'],
        },
        Format: {
            All: ['pdf', 'word', 'text', 'others'],
        },
        AddressType: {
            Home: 'Home',
            Office: 'Office',
            All: ['Home', 'Office'],
        },
        Genders: {
            Male: 'Male',
            Female: 'Female',
            NotDisclosed: 'Not disclosed',
            //Others: 'Others',
            All: ['Male', 'Female', 'Not disclosed'],
        },
        EmploymentType: {
            Permanent: 'Permanent',
            Intern: 'Intern',
            Other: 'Other',
            All: ['Permanent', 'Intern', 'Other'],
        },
        PaymentFrequencies: {
            Monthly: 'Monthly',
            BiWeekly: 'BiWeekly',
            Annual: 'Annual',
            Other: 'Other',
            All: ['Monthly', 'BiWeekly', 'Annual', 'Other'],
        },
        Sizes: {
            XS: 'XS',
            S: 'S',
            M: 'M',
            L: 'L',
            XL: 'XL',
            XXL: 'XXL',
            All: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
        },
    },
    Address: {
        Messages: {
            Error: {
                Add: 'Could not add employee\'s address, please try again later',
                Edit: 'Could not save employee\'s address, please try again later',
                Get: 'Could not get employee\'s address, please try again later',
                Find: 'Could not get employee\'s addresses, please try again later',
                Delete: 'Could not delete the employee\'s address, please try again later',
            },
        },
    },
    Document: {
        Type: {
            All: ['Handbook', 'Contract'],
        },
        Format: {
            All: ['pdf', 'word', 'text', 'others'],
        },
        Messages: {
            Error: {
                Add: 'Could not add employee document, please try again later',
                Get: 'Could not get employee document, please try again later',
                Find: 'Could not fetch employee documents, please try again later',
                Edit: 'Could not save employee document, please try again later',
                Delete: 'Could not delete employee document, please try again later',
            },
        },
    },
    Auth: {
        Messages: {
            Error: {
                Check: 'Authentication failed, please re-login and try again',
            },
        },
    },
    Announcement: {
        Messages: {
            Error: {
                Add: 'Could not add announcement, please try later',
                Get: 'Could not get announcement, please try later',
                Edit: 'Could not save announcement, please try later',
                Find: 'Could not find announcements, please try later',
                Delete: 'Could not delete announcement, please try later',
            },
        },
        Visibility: {
            Draft: 'Draft',
            Published: 'Published',
            All: ['Draft', 'Published'],
            Obj: [
                { name: 'draft', value: 'Draft' },
                { name: 'published', value: 'Published' },
            ],
        },
        Types: {
            General: 'General',
            Emergency: 'Emergency',
            All: ['General', 'Emergency'],
            Obj: [
                { name: 'general', value: 'General' },
                { name: 'emergency', value: 'Emergency' }],
        },
    },
};